<template>
  <div class="books_warp">
    <div class="books_container">
      <div class="title_icon"></div>
      <div class="bookBox">
        <div class="more" @click="toList">更多详情+</div>
        <div class="box3"></div>
        <div class="Xflex_box">
          <superslide
            :options="options"
            class="picMarquee-left"
            v-if="hackReset"
          >
            <div class="bd">
              <ul class="picList" ref="sliderWrap">
                <!-- @click="toDetail(item)" -->
                <li
                  class="bookItem"
                  v-for="(item, i) in bookList"
                  :key="i"
                  :data-id="item.id"
                >
                  <div class="cover">
                    <img :src="item.cover" :alt="item.name" />
                  </div>
                  <div class="info">
                    <div class="title">{{ item.title }}</div>
                    <p class="info-item">作者：{{ item.author }}</p>
                    <p class="info-item">出版社：{{ item.publisher }}</p>
                    <p class="info-item">出版年：{{ item.year }}</p>
                    <p class="info-item">索书号：{{ item.callNumber }}</p>
                  </div>
                </li>
              </ul>
            </div>

            <div class="hd" slot="titCell"></div>
            <div class="prev" slot="prev"></div>
            <div class="next" slot="next"></div>
          </superslide>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { post, get } from "@u/request";
export default {
  name: "picScrollLeft",
  data() {
    return {
      hackReset: true,
      bookList: [],
      options: {
        titCell: ".hd ul",
        mainCell: ".bd ul",
        autoPage: true,
        effect: "leftLoop",
        autoPlay: false,
        vis: 3,
      },
    };
  },
  watch: {},
  methods: {
    toList() {
      this.$router.push("/bookList");
    },
    toDetail(id) {
      this.$router.push(`/bookDetail/${id}`);
    },
    async loadList() {
      this.hackReset = false;
      const params = {
        publish: "1",
        pageNum: 1,
        pageSize: 6,
      };
      const { rows } = await get("lib/book/list", params).catch(() => {});
      this.bookList = rows;
      this.hackReset = true;
      this.eventListener();
    },
    handlerClick(e) {
      //获取点击元素的公共父级li;
      const li = e.target.closest("li");
      this.toDetail(li.dataset.id);
    },
    eventListener() {
      this.$nextTick(() => {
        const sliderWrap = this.$refs.sliderWrap;
        sliderWrap.addEventListener("click", this.handlerClick);
      });
    },
  },
  mounted() {},
  created() {
    this.loadList();
  },
};
</script>

<style>
/* 本例子css */
.picMarquee-left {
  /* overflow: hidden; */
  position: relative;
  margin-top: 26px;
}
.picMarquee-left .hd {
  height: 0px;
}

.picMarquee-left .bd {
  padding: 10px;
}
.picMarquee-left .bd ul {
  overflow: hidden;
  zoom: 1;
}
.picMarquee-left .bd ul li {
  margin: 0 8px;
  float: left;
  overflow: hidden;
}
.prev,
.next {
  position: absolute;
  display: block;
  overflow: hidden;
  cursor: pointer;
  height: 58px;
  width: 34px;
  background: url(../../assets/index/srightbg.png);
}
.next {
  right: -26px;
  top: 83px;
}
.prev {
  left: -21px;
  top: 83px;
  background: url(../../assets/index/sleftbg.png);
}
</style>

<style scoped lang="scss">
.box3 {
  border-top: 100px solid #004896;
  border-right: 100px solid transparent;
  height: 100px;
  width: 100px;
  position: absolute;
  top: 0px;
  left: 0px;
}
.books_warp {
  //   height: 500px;
  //   background: url(../../assets/bookbg.jpeg) no-repeat center center;
  //   background-size: 100% 100%;
  //   background-color: #d1e0f0;
  // background-image: linear-gradient(to right, #d1e0f0, #ecf2f9);
  .books_container {
    width: 1400px;
    height: 100%;
    padding: 0 0 70px 0;
    margin: 0 auto;
    position: relative;
    .title_icon {
      width: 573px;
      height: 305px;
      background: url(../../assets/newbook-bg.png) 100% no-repeat;
      background-size: 100% 100%;
    }

    .bookBox {
      position: relative;
      width: 100%;
      margin-top: -210px;
      padding: 30px 25px 50px;
      height: 340px;
      left: 0px;
      display: flex;
      // background: url(../../assets/newbook-data-b.png) 100% no-repeat;
      //   background-size: 100% 100%;
      // background: #b4d9fc;
      background: #3a72d4 url(../../assets/index/conbg.png) center bottom
        no-repeat;
      .more {
        cursor: pointer;
        position: absolute;
        right: 0;
        width: 100px;
        color: #ed8016;
      }

      .Xflex_box {
        margin: 0 auto;
        margin-top: 10px;
        height: 100%;
      }
      .bookItem .title {
        font-size: 14px;
        font-weight: 700;
      }
      .bookItem:hover .info .title {
        color: #1981f8;
      }

      .bookItem .info-item {
        padding: 4px 0;
      }
      .bookItem {
        cursor: pointer;
        display: flex;
        margin-top: 10px;
        width: 32%;
        height: 200px;
        background-color: #fff;
        .cover {
          width: 37%;
          height: 100%;
          img {
            height: 100%;
            width: 100%;
            border: 0;
          }
        }

        .cover:hover img {
          transform: scale(1.2);
          transition: all 1s ease 0s;
          -webkit-transform: scale(1.2);
          -webkit-transform: all 1s ease 00s;
        }

        .info {
          width: 63%;
          height: 100%;
          padding: 20px 17px 0 24px;
          .title {
            font-size: 17px;
            color: #094d99;
            margin-bottom: 6px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            word-break: break-all;
          }
          p {
            color: #777777;
            font-size: 13px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
}
</style>
